import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const MOD = { rmm: "Supervision RMM, logiciels, mises à jour", automation: "Résumé quotidien et rapports clients", branding: "Logo et lien d'assistance personnalisés" };
const eur = (n) => n.toLocaleString("fr-FR", { style: "currency", currency: "EUR" });

export const PlanPicker = ({ value, onChange, current }) => {
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/plans").then(({ data }) => setPlans(data)).catch(() => {}); }, []);
  if (plans.length < 2) return null;
  return (
    <div className="grid sm:grid-cols-2 gap-3 mb-5" data-testid="plan-picker">
      {plans.map((p) => {
        const on = value === p.plan_id;
        return (
          <button type="button" key={p.plan_id} onClick={() => onChange(p.plan_id, p)} data-testid={`plan-pick-${p.plan_id}`}
            className={`flex flex-col justify-start text-left rounded-lg border p-4 transition-colors ${on ? "border-blue-500 bg-blue-50 ring-1 ring-blue-500" : "border-slate-200 hover:border-slate-300"}`}>
            <div className="flex items-baseline justify-between gap-2">
              <p className="font-semibold">{p.name}{current === p.plan_id && <span className="ml-2 text-xs font-medium text-blue-700">formule actuelle</span>}</p>
              <p className="font-semibold">{eur(p.price_eur)}<span className="text-xs font-normal text-slate-500"> HT/tech/mois</span></p>
            </div>
            {p.description && <p className="text-sm text-slate-500 mt-1">{p.description}</p>}
            <ul className="mt-3 space-y-1 text-sm">
              <li className="flex gap-2"><Check className="h-4 w-4 text-green-600 mt-0.5" />Prise en main à distance</li>
              {p.modules.map((m) => <li key={m} className="flex gap-2"><Check className="h-4 w-4 text-green-600 mt-0.5" />{MOD[m] || m}</li>)}
            </ul>
          </button>
        );
      })}
    </div>
  );
};

export const ChangePlan = ({ billing, onDone }) => {
  const [sel, setSel] = useState(billing.plan?.plan_id);
  const [busy, setBusy] = useState(false);
  const apply = async () => {
    if (!window.confirm("Changer de formule ? La différence de prix est calculée au prorata sur la prochaine facture.")) return;
    setBusy(true);
    try {
      await api.post("/billing/plan", { plan_id: sel });
      toast.success("Formule modifiée");
      onDone();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div>
      <p className="text-sm text-slate-600 mb-2">Formule :</p>
      <PlanPicker value={sel} onChange={setSel} current={billing.plan?.plan_id} />
      {sel !== billing.plan?.plan_id && <Button onClick={apply} disabled={busy} data-testid="plan-change-btn">Passer à cette formule</Button>}
    </div>
  );
};
